import React, { useContext, useEffect, useState } from "react";

import { Link as RouterLink } from "react-router-dom";

import {
    Autocomplete,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EventBusyIcon from "@mui/icons-material/EventBusy";

import { stringToLocaleDateString } from "../../../../helpers";
import { UtenteLink } from "../../../common";
import { NavContext, NavRoutes } from "../../../contexts";
import { ProvinceContext } from "../ProvinceContext";

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

export const ProvinceList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props
}) => {
    const { getRouteTo } = useContext(NavContext);

    const { state } = useContext(ProvinceContext);

    const { province, regioniOptions } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    };

    const deleteClickHandler = async (data) => {
        if (onActionClick) onActionClick("Delete", data);
    };

    const addClickHandler = (data) => {
        if (onActionClick) onActionClick("Add", data);
    };

    const [validFilter, setValidFilter] = useState(true);

    useEffect(() => {
        if (province && onLoadMore) {
            onLoadMore(0, pageSize, searchText, validFilter);
        }
    }, [searchText]);

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value);
    };

    const [regioneFilter, setRegioneFilter] = useState(null);

    useEffect(() => {
        if (province && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText, validFilter, regioneFilter);
        }
    }, [pageIndex, pageSize, validFilter, searchText, regioneFilter]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}
            >
                {province ? province.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid item sx={{
                                "& .MuiInputBase-root": {
                                    color: "white",
                                },
                                "& .MuiFormLabel-root": {
                                    color: "white",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "white",
                                },
                            }}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="h6">Tutte le Province</Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "white !important",
                                        }}
                                    >
                                        <Autocomplete
                                            options={regioniOptions}
                                            onChange={(e, value) => {
                                                setRegioneFilter(value?.regioneId);
                                            }}
                                            value={
                                                regioniOptions.find(
                                                    (option) => option.regioneId == regioneFilter
                                                ) ?? null
                                            }
                                            renderInput={(params) => (
                                                <TextField {...params} label="Regione" />
                                            )}
                                            fullWidth
                                            sx={{ color: "white", minWidth: 200, marginX: 1 }}
                                        />
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setValidFilter(!validFilter);
                                                    }}
                                                    checked={validFilter}
                                                    sx={{ color: "white" }}
                                                />
                                                <Typography variant="caption">ATTIVI</Typography>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue" }}>
                            <TableRow>
                                <TableCell style={{ width: "30%" }}>Descrizione</TableCell>
                                <TableCell style={{ width: "10%" }}>Sigla</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inizio validità
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Fine validità
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {province &&
                                province.result.length > 0 &&
                                province.result.map((provincia, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Provincia, [
                                                                provincia.id,
                                                            ]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}
                                                        >
                                                            {provincia.descrizione ?? "-"}
                                                            {[
                                                                provincia.regione?.fineValidita,
                                                                provincia.fineValidita,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            provincia.fineValidita &&
                                                                                provincia.fineValidita <= new Date()
                                                                                ? "error"
                                                                                : "warning"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography fontSize={14}>
                                                        {provincia.sigla}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography align="center" fontSize={14}>
                                                        {provincia.inizioValidita.toLocaleDateString(
                                                            "it-IT"
                                                        )}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography align="center" fontSize={14}>
                                                        {provincia.fineValidita
                                                            ? provincia.fineValidita.toLocaleDateString(
                                                                "it-IT"
                                                            )
                                                            : '-'}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={provincia?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={provincia?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(provincia.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(provincia.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(provincia)}
                                                >
                                                    <Tooltip title="elimina provincia">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={province ? province.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
};
